import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "注：修改后所有该人员参与的项目将全部修改，请谨慎操作", -1)

import { withDefaults, reactive, ref } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseInput,
  BaseButton,
  XrkMessageBox
} from 'xrk-components';
import { modifyProjectPeopleUserName } from '../data-source/apis';
import { validatorPhone } from '@/utils/validator';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-person-edit',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } },
    row: { default: () => ({}) }
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const formRef = ref<BaseFormRef>(null);
const formData = reactive<{
  name: string;
  phone: number;
}>({
  name: props.row.name,
  phone: null
});
const onSave = async () => {
  await formRef.value.validate();
  await XrkMessageBox.confirm(
    '修改后所有该人员参与的项目将全部修改，请谨慎操作',
    '请确认是否修改'
  );
  await modifyProjectPeopleUserName({
    projectId: props.row.projectId,
    userId: props.row.userId,
    userName: formData.name,
    phone: formData.phone
  });
  emits('success');
  onCancel();
};
const onCancel = () => {
  props.remove();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "450px",
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "修改人员信息"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onSave,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          "label-width": "auto",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "姓名：",
              prop: "name",
              rules: [{ required: true, message: '姓名必填' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入姓名",
                  modelValue: formData.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
                  maxlength: "30"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "手机号：",
              prop: "phone",
              rules: [
            {
              required: true,
              trigger: 'blur',
              validator: _unref(validatorPhone)
            }
          ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入手机号",
                  modelValue: formData.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.phone) = $event)),
                  type: "tel",
                  maxlength: "11"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _hoisted_2
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})